export default "__VITE_ASSET__DwcgFNNX__"